module.exports = __webpack_public_path__ + "img/icon_top_bg_101.5b8dc72d.svg";